/**************************************************************************************************************************************************
*   MODULE NAME     :  Dashboard Tab
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  22-03-2021
*   DESCRIPTION     :  Component to load Dashboard Results Tab
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG2517014
*   DESCRIPTION: <GLSD>: Layer7 API Deprecation
*   removed unused/commented code 
*   DATE: 28-Feb-2025
/**************************************************************************************************************************************************/

import React from "react";
import {
  Container,
  Row,
  Col,
  OverlayTrigger,
  Button,
  Popover,
} from "react-bootstrap";
import {
  FaSpinner,
  FaExclamationTriangle,
  FaTimes,
  FaFile,
  FaHashtag,
} from "react-icons/fa";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import swal from "sweetalert";
import { loadGlobalDashboardDetails } from "../../actions/homeActions";
import { loadAllAlerts } from "../../actions/abstractActions";
import { ddmmmyyyyFormat } from "../common/DateFormat";
import {} from "../common/MessagesPool";
import DataTable from "../common/dataTable/DataTable";
import Loader from "../common/Loader";
import queryString from "query-string";
import { exportPDF } from "../common/ExportToPDF";

class DashboardTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      site: this.props.site,
      datatype: this.props.datatype,
      alertMasterData: this.props.alertMasterData,
      title: this.props.title,
      paginationData: {
        searchText: "",
        startFrom: 0,
        perPageLimit: 10,
        sortField: "id",
        sortOrder: "asc",
        count: 0,
        page: 1,
        searchCount: 0,
      },
      isLoading: false,
      data: [],
    };
  }
  loadData = ({
    searchText,
    sortField,
    sortOrder,
    filters,
    page,
    sizePerPage,
  }) => {
    const startFrom = (page - 1) * sizePerPage;
    let paginationData = {
      searchText: (searchText === undefined ? '' : searchText),
      startFrom,
      perPageLimit: sizePerPage,
      sortField,
      sortOrder,
      page,
    };
    
    if((searchText != this.state.paginationData.searchText)) {
      paginationData.page = 1;
      paginationData.startFrom = 0;
    }
    
    this.setState({ paginationData }, this.loadDashboardDetails);
  };
  compareDate(_date, _days) {
    var date_C = new Date(_date);
    date_C.setDate(date_C.getDate() + _days);
    return date_C <= new Date();
  }

  loadDashboardDetails = () => {
    this.setLoader(true);
    let { paginationData, datatype, site } = this.state;
    this.props
      .loadGlobalDashboardDetails(datatype, site, paginationData)
      .then(async (res) => {
        
        if (res && res.data && res.data.result) {
          let data = res.data.result;
          const { count, searchCount } = data;
          data.list = await this.mapAbstractsAttributes(data.list);
          this.setState(
            {
              data: data.list,
              paginationData: {...paginationData, count, searchCount},
            },
            () => this.setLoader(false)
          );
        }
      })
      .catch((error) => {
        this.setLoader(false);
      });
  };
  async generateAlert(abstract) {
    let alertFlag = false;
    let alertTitle = "";
    if (this.state.alertMasterData === null) {
      await this.loadAlertsData();
    }

    const { alertMasterData } = this.state;
    if (
      abstract.migrateFlag === false
    ) {
      if (!abstract["dateAbstractReviewed"]) {
        alertFlag = this.compareDate(
          abstract["dateRecordReceived"],
          parseInt(alertMasterData["ALERT_DAYS_ABST_NOT_REVD"])
        );
        alertTitle = "Abstract Not Reviewed";
      } else if (
        abstract["dateTranslationRequested"] &&
        !abstract["dateTranslationReceived"]
      ) {
        alertFlag = this.compareDate(
          abstract["dateTranslationRequested"],
          parseInt(alertMasterData["ALERT_DAYS_ART_NOT_RECVD"])
        );
        alertTitle = "Translation Not Returned";
      } else if (
        abstract["dateArticleOrdered"] &&
        !abstract["dateArticleReceived"]
      ) {
        alertFlag = this.compareDate(
          abstract["dateArticleOrdered"],
          parseInt(alertMasterData["ALERT_DAYS_ART_NOT_REVD"])
        );
        alertTitle = "Article Not Received";
      } else if (
        abstract["dateArticleReceived"] &&
        !abstract["dateArticleReviewed"]
      ) {
        alertFlag = this.compareDate(
          abstract["dateArticleReceived"],
          parseInt(alertMasterData["ALERT_DAYS_TRANS_NOT_RET"])
        );
        alertTitle = "Article Not Reviewed";
      } else if (
        abstract["dateTranslationReceived"] &&
        !abstract["dateArticleReviewed"]
      ) {
        alertFlag = this.compareDate(
          abstract["dateTranslationReceived"],
          parseInt(alertMasterData["ALERT_DAYS_TRANS_NOT_RET"])
        );
        alertTitle = "Article Not Reviewed";
      } else {
        alertFlag = false;
      }
    }
    return alertFlag;
  }
  mapAbstractsAttributes = async (abstracts) => {
    if (abstracts && Array.isArray(abstracts))
      abstracts = await Promise.all(abstracts.map(async (abstract) => {
        abstract.alert = await this.generateAlert(abstract);
        return abstract;
      }));
    return abstracts;
  };
  setLoader = (isLoading) => this.setState({ isLoading });

  openAbstractDetailWindow = (abstractId) => {
    window.open(
      `/abstractDetail/${abstractId}`,
      "",
      `width=${window.innerWidth},height=${window.innerHeight}`
    );
  };
  openDashboardResultsWindow = () => {
    let { site, datatype, title } = this.state;
    let query = queryString.stringify({ title });
    window.open(
      `/dashboardresults/${site}/${datatype}?${query}`,
      "",
      `width=${window.innerWidth},height=${window.innerHeight}`
    );
  };
  handlePrintFunction = async () => {
    this.exportFile();
  };
  exportFile() {
    const { data } = this.state;
    let colSelected = [
      "dateRecordReceived",
      "dateArticleReceived",
      "dateTranslationReceived",
      "dateClosed",
    ];
    var headers = [
      [
        "Alert",
        "Title",
        "Author",
        "Product",
        "Status",
        "Date Record Received",
        "Date Article Received",
        "Date Translation Received",
        "Date Closed",
      ],
    ];
    var widths = [20, 205, 125, 65, 65, 50, 50, 50, 50];
    data.sort((a, b) => (a.title > b.title ? 1 : -1));

    const dataDashboard = data.map((elt) => {
      let element;
      let alert = "";
      alert =
        alert +
        (elt.migrateFlag == true
          ? "#"
          : "");
      alert = alert + (elt.active === false ? "X" : "");
      alert =
        alert +
        (elt.active === true && elt.enblAlrtsAndVldtinsFlag == true
          ? "!"
          : "");

      if (elt.product)
        element = [
          alert,
          elt.title,
          elt.authors,
          elt["product"]["masterDataValue"],
          elt["status"]["masterDataValue"],
        ];
      else
        element = [
          alert,
          elt.title,
          elt.authors,
          elt["product"],
          elt["status"]["masterDataValue"],
        ];
      colSelected.forEach((ele) => {
        let dt =
          ele.includes("date") && elt[ele]
            ? ddmmmyyyyFormat(elt[ele])
            : elt[ele]
            ? elt[ele]
            : "";

        element.push(dt);
      });
      return element;
    });
   
    let titlepdf = this.state.title ? this.state.title : " ";
    exportPDF(
      "Dashboard Results",
      titlepdf,
      headers,
      dataDashboard,
      widths,
      ""
    );
  }
  render() {
    const {
      data,
      isLoading,
      paginationData: { page, count, searchCount },
    } = this.state;
    let columns = [
      {
        dataField: "abstractId",
        text: "Abstract",
        hidden: true,
      },
      {
        dataField: 'alert',
        text: 'Alert',
        csvExport: false,
        headerClasses: "width-5",
        headerStyle: (colum, colIndex) => {
          return { width: '5vw' };
        },
        formatter: (cellContent, row) => {
          return <span style={{ display: 'inline-block', position: 'relative' }}>
            {row && (row.migrateFlag == true )
              && <FaHashtag style={{ color: 'gray' }} />}
            {row && row.active === false && <FaTimes style={{ color: 'red' }} />}
            {row && row.alert && row.active === true && row.enblAlrtsAndVldtinsFlag == true && <FaExclamationTriangle style={{ color: 'orange' }} />}
          </span>;
        }
      },
      {
        dataField: "title",
        text: "Title",
        searchable: true,
        hidden: true,
      },
      {
        dataField: "title",
        text: "Title",
        searchable: true,
        sort: true,
        style: { textAlign: "left" },
        formatter: (cellContent, row) => {
          const _popOver = (
            <OverlayTrigger
              placement="right"
              popperConfig={{
                modifiers: {
                  preventOverflow: {
                    enabled: false,
                  },
                },
              }}
              overlay={
                <Popover style={{ maxWidth: "50vw" }} id="popover-contained">
                  <Popover.Content>{row.title}</Popover.Content>
                </Popover>
              }
            >
              <span
                className="fake-link"
                onClick={() => this.openAbstractDetailWindow(row.abstractId)}
              >
                {row.title && row.title.length <= 70
                  ? row.title
                  : row.title && row.title.substr(0, 70) + "..."}
              </span>
            </OverlayTrigger>
          );
          return row && row.title ? _popOver : "";
        },
      },
      {
        dataField: "authors",
        text: "Author(s)",
        searchable: true,
        hidden: true,
      },
      {
        dataField: "authors",
        text: "Author(s)",
        searchable: true,
        sort: true,
        style: { textAlign: "left" },
        headerStyle: (colum, colIndex) => {
          return { textTransform: 'none' };
        },
        formatter: (cellContent, row) => {
          const _popOver = (
            <OverlayTrigger
              placement="right"
              popperConfig={{
                modifiers: {
                  preventOverflow: {
                    enabled: false,
                  },
                },
              }}
              overlay={
                <Popover style={{ maxWidth: "40vw" }} id="popover-contained">
                  <Popover.Content>{row.authors}</Popover.Content>
                </Popover>
              }
            >
              <div>
                {row.authors&& row.authors.length <= 70
                  ? row.authors
                  : row.authors && row.authors.substr(0, 70) + "..."}
              </div>
            </OverlayTrigger>
          );
          return row && row.authors ? _popOver : "";
        },
      },
      {
        dataField: "productId",
        headerClasses: "width-100",
        text: "Product",
        searchable: true,
        sort: false,
        formatter: (cellContent, row) => {
          return row && row.product && row.product.masterDataValue
            ? row.product.masterDataValue
            : "";
        },
      },
      {
        dataField: "statusId",
        text: "Status",
        searchable: true,
        headerClasses: "width-120",
        sort: false,
        formatter: (cellContent, row) => {
          return row && row.status && row.status.masterDataValue
            ? row.status.masterDataValue
            : "";
        },
      },
      {
        dataField: "dateRecordReceived",
        text: "Date Record Received",
        headerClasses: "width-120",
        searchable: true,
        sort: true,
        formatter: (cellContent, row) => {
          return row &&
            row.dateRecordReceived &&
            !isNaN(new Date(row.dateRecordReceived).getTime())
            ? ddmmmyyyyFormat(row.dateRecordReceived)
            : "";
        },
      },
      {
        dataField: "dateArticleReceived",
        text: "Date Article Received",
        headerClasses: "width-120",
        searchable: true,
        sort: true,
        formatter: (cellContent, row) => {
          return row &&
            row.dateArticleReceived &&
            !isNaN(new Date(row.dateArticleReceived).getTime())
            ? ddmmmyyyyFormat(row.dateArticleReceived)
            : "";
        },
      },

      {
        dataField: "dateTranslationReceived",
        headerClasses: "width-120",
        text: "Date Translation Received",
        searchable: true,
        sort: true,
        formatter: (cellContent, row) => {
          return row &&
            row.dateTranslationReceived &&
            !isNaN(new Date(row.dateTranslationReceived).getTime())
            ? ddmmmyyyyFormat(row.dateTranslationReceived)
            : "";
        },
      },

      {
        dataField: "dateClosed",
        headerClasses: "width-120",
        text: "Date Closed",
        searchable: true,
        sort: true,
        formatter: (cellContent, row) => {
          return row &&
            row.dateClosed &&
            !isNaN(new Date(row.dateClosed).getTime())
            ? ddmmmyyyyFormat(row.dateClosed)
            : "";
        },
      },
    ];
    return (
      <>
        <div className="abstractWrap mt-2">
          <Container fluid>
            <div className="filter-action-section">
              <Row>
                
                <Col sm={12} className="btns mb-0">
                  <div className="float-right form-inline">
                    <div className='mr-3'>
                      <Button
                        className="addBtn"
                        variant="btn btn-primary"
                        onClick={this.openDashboardResultsWindow}
                      >
                        Show All Abstracts
                      </Button>
                    </div>
                    <div className='mr-3'>
                      <Button
                        className="addBtn"
                        variant="btn btn-primary"
                        onClick={this.handlePrintFunction}
                      >
                        Print Results
                      </Button>
                    </div>
                    </div>
                </Col>
              </Row>
            </div>
            <div className="leftAbstractList abstract-datatable">
              <DataTable
                keyField="abstractId"
                defaultSortField="title"
                data={data}
                columns={columns}
                csvName={false}
                showSearch={true}
                showPagination={true}
                loadData={this.loadData}
                totalSize={count}
                searchCount={searchCount}
                page={page}
                remote
              />
            </div>
          </Container>
        </div>
        {isLoading && (
          <div className="loader">
            <FaSpinner />
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      loadGlobalDashboardDetails,
      loadAllAlerts,
    },
    dispatch
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DashboardTab)
);